export const BOX_OPTIONS = ["With Box", "No Box"];

export const PAPER_OPTIONS = ["Paper", "Card", "E-Warranty", "No Paper"];

// Matches the admin panel's wording so a watch reads the same in the shop and
// on its invoice. The stored values keep their original spelling - they are
// what the product filter sends to the API - so only the label changes, and
// only for the two affirmative choices.
export const PAPER_LABELS = {
  Paper: "With Paper",
  Card: "With Card",
};

export const formatPaperLabel = (value) => PAPER_LABELS[value] ?? value;

export const ORIGIN_OPTIONS = ["Foreign", "Local"];

export const CONDITION_FILTERS = [
  { key: "latest", label: "Latest" },
  { key: "men/unisex", label: "Men's/Unisex" },
  { key: "women", label: "Women's" },
  { key: "new", label: "New" },
  { key: "pre-owned", label: "Pre-Owned" },
];

export const ADVANCED_FILTERS = [
  { key: "dial", label: "Dial" },
  { key: "dialNumerals", label: "Dial Numerals" },
  { key: "case", label: "Case" },
  { key: "caseDiameter", label: "Case Diameter" },
  { key: "movement", label: "Movement" },
  { key: "caliber", label: "Caliber" },
  { key: "band", label: "Band" },
  { key: "bandDescription", label: "Band Description" },
  { key: "year", label: "Year" },
  { key: "box", label: "Box" },
  { key: "paper", label: "Paper Type" },
  { key: "origin", label: "Origin" },
];

export const SERVICE_MESSAGES = {
  buy: "Hi, I'm interested in buying a watch. Can you help me?",
  sell: "Hi, I'd like to sell my watch. Can we discuss the details?",
  trade:
    "Hi, I'm interested in trading in my watch. Can we discuss the options?",
  consignment:
    "Hi, I'd like to consign my watch. Can you provide more details?",
  preorder:
    "Hi, I'd like to pre-order a specific watch. Can you help me source it?",
};
